import { render, staticRenderFns } from "./plugin-delay.vue?vue&type=template&id=1979fd5a&scoped=true&"
import script from "./plugin-delay.vue?vue&type=script&lang=js&"
export * from "./plugin-delay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1979fd5a",
  null
  
)

export default component.exports